export default __webpack_public_path__ + "static/media/construction--flat--crosswalk-plain.3d80b1ca.png";